import { Injectable } from '@angular/core';

/** La elección del comercio, por dispositivo. Sin ella se sigue al sistema. */
export const THEME_STORAGE_KEY = 'theme';

/**
 * Tema claro u oscuro: `body.dark` activa los tokens oscuros de `theme/variables.scss`. Lo
 * aplica `AppComponent` al arrancar; lo cambian el botón de la barra lateral (PC) y el de la
 * cuenta (celular).
 */
@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  dark = false;

  init(): void {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    this.apply(stored === 'dark' || stored === 'light' ? stored === 'dark' : this.systemPrefersDark());
  }

  toggle(): void {
    this.apply(!this.dark);
    localStorage.setItem(THEME_STORAGE_KEY, this.dark ? 'dark' : 'light');
  }

  private apply(dark: boolean): void {
    this.dark = dark;
    document.body.classList.toggle('dark', dark);
  }

  private systemPrefersDark(): boolean {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
}
